<app-header></app-header>
<app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

<div class="wrapper">


    <app-estimate-tab-box *ngIf="singleFormSubmit && (historyState?.isPaymentDone || hidePlanSelection)"
        [isLoader]="isUploading" (saveBtnClick)="saveImages('save&wait')"
        (closeBtnClick)="close()"></app-estimate-tab-box>

    <div class="section_wrapper" style="margin-top: 20px;">
        <div class="dashBoard photos_wrap">
            <app-stepper-save class="stepper-sell" [tabToSelect]="'Photos'" (tabBtnClick)="switchTab($event)"
                *ngIf="singleFormSubmit && (historyState?.isPaymentDone || hidePlanSelection)"></app-stepper-save>
            <div class="photos w_100">
                <div class="heading-wrap">
                    <h3 class="font_40_a32">Photos</h3>
                </div>
                <ul class="photo_restrictions">
                    <li>Optional: If you already have your photos, you may upload your photos here. You may add, update,
                        or
                        remove your photos at any time in the listing process.
                    </li>
                    <li>Photos must be original photo files and can not be Google Maps, Google Earth images, screenshots
                        of
                        photos, thumbnail versions of photos, or owned by someone else. Images from previous listing may
                        be
                        owned by the agent who paid for them.
                    </li>
                    <li>

                        Once all the photos are uploaded, you can rearrange them to display in your desired order on the
                        listing.
                    </li>
                </ul>

                <div class="example-form mt-10">
                    <div class="fields">
                        <mat-checkbox color="secondary" [checked]="photographyRelease" color="#81B5B1"
                            (change)="changePhotographyRelease()">
                            <p>Photography Release (I own these photos or have explicit permission to use them for
                                publishing to
                                the MLS)</p>
                        </mat-checkbox>
                    </div>
                    <mat-error class="error-message mt-10"
                        *ngIf="photographyRelease != true && submitted &&  alreadyUploadedImages.length > 0"><img
                            src="../../../assets/images/info.png">Please
                        Confirm
                    </mat-error>
                </div>

                <div *ngIf="!isUploading" class="dropzone center" (drop)="onDrop($event)"
                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
                    <div class="drop">
                        <div class="upload-div">
                            <div class="img-div">
                                <div class="gallery_icon"></div>
                            </div>
                            <div>
                                <p class="drag_text">Drag your photos here</p>
                                <p class="format_text">
                                    You can upload JPEG, JPG, PNG, HEIC file format
                                </p>
                            </div>
                        </div>
                        <div class="text_divider">OR</div>
                        <div>
                            <label for="file-upload" class="upload_btn">
                                UPLOAD FROM YOUR DEVICE
                            </label>
                            <input id="file-upload" type="file" multiple (change)="selectFiles($event)"
                                accept="image/*">
                        </div>
                    </div>
                </div>

                <br>
                <h3><b class="upload-img">Uploaded Images</b> (Drag to reorder photos)</h3>

                <div class="selected_images"
                    [ngStyle]="{'margin-top': alreadyUploadedImages.length == 0 ? '0' : '36px'}" cdkDropList
                    [cdkDropListData]="alreadyUploadedImages" (cdkDropListDropped)="drop($event)">
                    <div class="image_wrap" *ngFor="let previewsItem of alreadyUploadedImages; let i = index" cdkDrag>
                        <button class="delete_icon" (click)="deleteImages(i)">
                            <img src="../../../assets/icons/delete_icon.svg" alt="">
                        </button>
                        <button class="drag_icon">
                            {{i+1}}
                        </button>
                        <div class="image_container" style="position: relative;">
                            <img class="preview_image" [src]="previewsItem.url" alt="">
                            <div *ngIf="previewsItem.loading" class="spinner"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

</div>

<ng-template #confirmationDialog>
    <div class="addGroupWrap">
        <div matDialogTitle>
            <span class="dialog-title">Confirm</span>
            <button mat-icon-button class="close-icon" (click)="closeDialog('close')">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div mat-dialog-content class="pt-2">
            <div>
                Do you like to move without saving the changes?
            </div>
        </div>
        <mat-dialog-actions>
            <div class="w-100 text-right">
                <button mat-button type="button" class="outlineBtn ml-1" (click)="closeDialog(closeFlag)">Close</button>
                <button class="ml-1 submitBtn" type="submit" cdkFocusInitial mat-flat-button color="primary"
                    (click)="saveImages(saveFlag)">
                    Save
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</ng-template>